export default __webpack_public_path__ + "static/media/membership-upgrade.1456b00e.gif";